import React from "react";
import heroImage from "../../images/v2/banner08.png";
import { FAQ_PAGE_HERO } from "./faqPageConfig";

// asHeading=false 이면 상세페이지(칼럼 제목이 H1)에서 히어로 제목을 h1이 아닌
// 일반 텍스트(p)로 렌더해, 페이지 내 H1이 1개만 유지되도록 한다.
// label/title/description 을 넘기면 기본 FAQ 문구 대신 사용한다(카테고리 페이지 등).
export const FaqHero = ({
  asHeading = true,
  label = FAQ_PAGE_HERO.label,
  title = FAQ_PAGE_HERO.title,
  description = FAQ_PAGE_HERO.description,
}) => {
  const TitleTag = asHeading ? "h1" : "p";

  return (
    <section
      className="faq-page-hero"
      {...(asHeading ? { "aria-labelledby": "faq-page-hero-title" } : {})}
    >
      <img className="faq-page-hero__bg" src={heroImage} alt="" aria-hidden />
      <div className="faq-page-hero__overlay" aria-hidden />
      <div className="faq-page-hero__inner">
        <p className="faq-page-hero__label">{label}</p>
        <TitleTag
          {...(asHeading ? { id: "faq-page-hero-title" } : {})}
          className="faq-page-hero__title"
        >
          {title}
        </TitleTag>
        <p className="faq-page-hero__desc">
          {description.split("\n").map((line, index, lines) => (
            <React.Fragment key={index}>
              {line}
              {index < lines.length - 1 && <br />}
            </React.Fragment>
          ))}
        </p>
      </div>
    </section>
  );
};
